import styled from 'styled-components';

export const ContactDisclosure = styled.span`
  display: block;
  line-height: 18px;
  font-size: 12px;
  color: ${props => props.theme.grayDark};
`;
